import { useDispatch } from 'react-redux'
import * as routerActions from 'connected-react-router'

// Components
import { PageHeading, Layout, Image, EmptyState } from '@tracklib/kit'
import SEO from 'components/base/seo'
import InfoItem2 from 'components/base/infoitem2'

// Hooks
import { useGenres } from 'modules/entities/hooks'

import styles from './genres.css'

const Genres = () => {
  const dispatch = useDispatch()
  const genres = useGenres()

  const genreList = Object.keys(genres || {}).map(id => genres[id])

  return (
    <>
      <SEO title="Genres | Tracklib" />
      <PageHeading heading="Genres" description="Everything from blues to soul, rock to Bollywood. We got it." />
      <Layout.FullWidth>
        <ol className={styles.list}>
          {genreList.length ? (
            genreList
              .filter(x => !x.parent)
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(genre => {
                const children = genreList.filter(child => child.parent === genre.id)
                return (
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={e => {
                      if (e.target.tagName !== 'A') {
                        return dispatch(routerActions.push(`/genre/${genre.slug}`))
                      }
                      return null
                    }}
                    key={genre.id}
                    datatesting="entity_genre"
                    className={styles.genreLink}
                  >
                    <li className={styles.genre}>
                      <div className={styles.image}>
                        <Image image={genre.image} absolute />
                      </div>
                      <div className={styles.content}>
                        <h3 className={styles.name}>{genre.name}</h3>
                        <ul>{children && <InfoItem2 genres={children} title="Sub-genres" showAll displayAsRow />}</ul>
                      </div>
                    </li>
                  </div>
                )
              })
          ) : (
            <EmptyState text="No genres found" emoji="looking" />
          )}
        </ol>
      </Layout.FullWidth>
    </>
  )
}

export default Genres
